export default class UnauthorizedError extends Error {
  public cause: any;

  constructor(cause?: any) {
    super('User is not signed in or does not have access to data');

    Object.setPrototypeOf(this, new.target.prototype);

    this.cause = cause;
  }
}
